import { Image } from 'primereact/image';
import React, { useState, useEffect, useRef } from "react";
import { TieredMenu } from 'primereact/tieredmenu';
import { OverlayPanel } from 'primereact/overlaypanel';
import { ScrollPanel } from 'primereact/scrollpanel';
import { Link, useNavigate } from "react-router-dom";
import { Auth } from 'aws-amplify';
import { reactLocalStorage } from 'reactjs-localstorage';
import NewAgreementLogo from '../../../src/assets/images/new_agreement_logo.svg';
import ProfileIMG from '../../../src/assets/images/profile.png';
import PreviewAgreement from '../../../src/assets/images/preview-agreement.png';
import { Dialog } from 'primereact/dialog';
import { Tab, Tabs, TabList, TabPanel } from "react-tabs";
import JsPDF from 'jspdf';
import PsaPdf3 from '../../components/reportpdftemplate/Personalserviceagreementpdf3';


import "react-tabs/style/react-tabs.css";


// import PsaPdf from "../../components/reportpdftemplate/personalserviceagreementpdf";
import { Margin, usePDF } from 'react-to-pdf';
import PsaPdf from '../../components/reportpdftemplate/personalserviceagreementpdf';
export default function PSAConsultant(props) {

  const menu = useRef(null);
  const childRef = useRef();

  const notification = useRef(null);
  const mail = useRef(null);
  var myNavigation = useNavigate();
  const [Confirm, setConfirm] = useState(false);
  const [loaderPdf, setLoaderPdf] = useState(false);

  const [buttonDisabled, setButtonDisabled] = useState(false);

  const handleClick = () => {
    setButtonDisabled(true);
    setTimeout(() => {
      setButtonDisabled(false);
    }, 5000);

  };

  console.log(props, "props12345678")
  const items = [
    // {
    //   label: 'View profile',
    //   icon: 'gusd-user',
    //   url: '/initiatorprofile'
    // },
    {
      label: 'Change Password',
      icon: 'gusd-lock',
      url: '/changepassword'
    },
    {
      label: 'Switch Account',
      icon: 'gusd-switch-account',
      items: [
        {
          label: 'Admin'
        },
        {
          label: 'Initiator'
        },
        {
          label: 'Approver'
        },
        {
          label: 'Payroll'
        },
        {
          label: 'PSA Consultant'
        },
        {
          label: 'Initiators After Board Meeting'
        }
      ]
    },
    {
      separator: true
    },
    {
      label: 'Log out',
      icon: 'gusd-logout',
      command: async () => {
        await Auth.signOut({ global: false });
        reactLocalStorage.clear();
        myNavigation('/');
      }
    }
  ];

  // const generatePDF = () => {

  //   const report = new JsPDF('landscape','pt','a3');
  //   report.html(document.querySelector('#psaConsultantPdfReport')).then(() => {
  //       report.save('GUSD New Service Agreement.pdf');
  //   });


  // }

  const { toPDF, targetRef } = usePDF(
    {
      method: "save",
      filename: 'GUSD New Service Agreement.pdf',
      page: { margin: Margin.SMALL },
    }
  );

  return (
    <>

      {/*Col-8*/}
      <div className='col-span-8'>
        <div className='lg:px-[5.573vw] px-[80px] xl:py-[1.667vw] py-[30px]' data-aos="fade-down" data-aos-duration="700" data-aos-delay="500">
          {/*form*/}
          <div className='text-[#000000] font-bold xl:text-[1.406vw] text-[24px]'>GUSD New Service Agreement</div>

          <div className='xl:p-[1.250vw] p-[20px] bg-[#F5F6F7] flex items-center justify-between'>
            <div className='flex items-center space-x-2 text-[#000000] font-medium xl:text-[1.250vw] text-[20px]'>
              <span className='gusd-file-icon w-4 h-4 inline-block'></span><span>GUSD New Service Agreement.pdf</span>
            </div>
            <div className='text-[#113699] text-xs xl:text-[0.729vw] font-medium -tracking-[0.28px] flex items-center space-x-2 cursor-pointer'
              onClick={() => {
                // generatePDF()
                // toPDF();
                  setLoaderPdf(true)
                childRef.current.generatePDF();

              }}
            ><i className='PDF_Download_Icon'></i>
              {
                loaderPdf === true ?
                  <span>Please Wait...</span>
                  :
                  <>
                    <span>Download PDF</span>
                  </>
              }
            </div>
          </div>


          {props.initiatorDocuments?.length > 0 && (
            <>
              <div className="flex justify-between  items-center gap-1 mt-2">
                <div className='flex gap-2'>
                  <span>Uploaded Documents</span>
                  <span className="gusd-file-icon mt-1.5 w-4 h-4 inline-block"></span>
                </div>
                {props.initiatorDocuments?.length > 0 ? (
                  <>
                    <div className=" bg-[#F5F6F7] flex items-center justify-between">
                      <div className="flex items-center gap-1 text-[#000000] font-medium xl:text-[1.250vw] text-[20px]">
                        <div className="col mt-2">
                          <div class="border border-dashed border-gray-500 relative" style={{ padding: "10px" }}>
                            {props.initiatorDocuments.map(res => {
                              return (
                                // <div class="text-center p-10 absolute top-0 right-0 left-0 m-auto">
                                // <h5>
                                <p
                                  className="psa-attachments-notes-remove-btn"
                                  style={{ cursor: "pointer", fontSize: "14px" }}
                                  onClick={() => {
                                    res?.filepath && props.OpenDocument(res?.filepath);
                                  }}
                                >
                                  {res?.filename}
                                </p>
                                // </h5>
                                // </div>
                              );
                            })}
                          </div>
                        </div>
                      </div>
                    </div>
                  </>
                ) : (
                  ""
                )}
              </div>
            </>
          )}


          <div className='xl:p-[1.250vw] p-[20px] bg-[#F5F5F5] rounded-bl rounded-br'>
            <div id='psaConsultantPdfReport'>
              <PsaPdf
                // refPrint={targetRef}
                ref={childRef}
                setLoaderPdf={setLoaderPdf}
                agreementDate={props.psaDetail.agreementDate}
                partyName={props.partyName}
                amount={props.psaDetail.amount}
                psaConsultantId={props.id}
                services={props.psaDetail.services}
                effectiveDate={props.psaDetail.effectiveDate}
                expirationDate={props.psaDetail.expirationDate}
                typeOfBusinessEntityAandN={props.psaDetail.typeBE}
                submittedTo={props.psaDetail.submittedTo?.name}
                referenceNo={props.psaDetail.referenceNo}
                purchaseOrderNo={props.psaDetail.purchaseOrderNo}
                addendumNo={props.psaDetail.addendumNo}
                businessEntity={props.psaDetail.businessEntity}
                typeBE={props.typeBE}
                otherTypeBE={props.otherTypeBE}
                submittedCompletedFormTo={props.psaDetail.submittedCompletedFormTo}
                accountNumber={props.psaDetail.accountNumber}

                // typeBE2={pSAPartyData.typeBE}
                // PSA Consultant details
                typeOfBusinessEntityPartyDetails={props.psaDetail.typeOfBusinessEntityPartyDetails}
                title={props.title}
                city={props.city}
                licenseNumber={props.license}
                // addressPSa={props.address}
                addressPSa={` ${props?.state ? props?.state : ""} ${props?.city ? props.city : ""}  ${props?.address ? props?.address : ""} ${props?.zip ? props?.zip : ""}`}
                psaDate={props.psaDetail.psaDate}
                contactNumber={props.pocNumber}
                pocNumber={props.pocNumber}
                fax={props.psaDetail.fax}
                pocName={props.pocName}
                //Tax Identification Details
                socialSecurityNumber={props.ssn}
                employerIdentification={props.employerId}
                //Gusd Detailes
                gusdDate={props.psaDetail.gusdDate}
                dateOfBoardMeeting={props.psaDetail.dateOfBoardMeeting}
                BoardItem={props.psaDetail.boardItem}
                pageItem={props.psaDetail.pageItem}
                superintendentAssistent={props.psaDetail.superintendentAssistent}
                calpers={props.calpers}
                strs={props.strs}
                updatedAt={props?.updatedAt}
              />
            </div>
          </div>

          <div className="flex flex-wrap items-center justify-center md:justify-end xl:gap-[0.521vw] gap-[8px] mt-10">
            <div className="inline-block text-[#344054] text-[16px] xl:text-[0.833vw] font-medium bg-white hover:bg-[#f5f5f5] border border-[#D0D5DD] rounded-[8px] xl:rounded-[0.417vw] py-[10px] xl:py-[0.521vw] px-[18px] xl:px-[0.938vw] cursor-pointer"
              onClick={() => {

                props.setTab1(false);
                props.setTab2(true);
                props.setTab3(false);

              }}><span>Previous</span></div>
            <button
              className="xl:py-[0.833vw] py-[14px] xl:px-[1.458vw] px-[24px] text-[#101828] rounded-lg font-semibold text-sm xl:text-[0.833vw] space-x-2 cursor-pointer"
              disabled={props.buttonClicked}
              onClick={async () => {
                await Auth.signOut({ global: false });
                reactLocalStorage.clear();
                myNavigation('/');
              }}
            >
              <i className="gusd-close text-xs"></i>
              <span>Cancel</span>
            </button>
            <button
              onClick={() => {
                props.rejectSelectedReport(props.id);
              }}
              disabled={props.buttonClicked}
              className="xl:py-[0.833vw] py-[14px] xl:px-[1.458vw] px-[24px] text-[#D92D20] rounded-lg font-semibold text-sm xl:text-[0.833vw] space-x-2 cursor-pointer"
            >
              <i className="gusd-close-circle-bold text-base"></i>
              <span>Reject</span>
            </button>

            <button
              onClick={() => {
                props.saveSelectedReport(props.id);
                handleClick()
              }}
              // disabled={props.pleaseWaitBtn}
              disabled={props.pleaseWaitBtn || buttonDisabled}
              className="xl:py-[0.833vw] py-[14px] xl:px-[1.458vw] px-[24px] bg-[#113699]  text-white rounded-lg font-semibold text-sm xl:text-[0.833vw] space-x-2 cursor-pointer"

            >
              {" "}
              <i className="gusd-check-circle text-sm"></i>
              {/* <span>{(props.buttonClicked)?"Please Wait":'Confirm'}</span> */}
              <span>{(props.pleaseWaitBtn) ? "Please Wait" : 'Confirm'}</span>
            </button>
          </div>
          {/*form*/}

          <Dialog className='Confirm_popup' visible={Confirm} style={{ width: '30vw' }} onHide={() => setConfirm(false)}>
            <div className='flex flex-col items-center justify-center gap-3'>
              <div className='text-[#0487C8] font-medium text-base xl:text-[0.938vw] flex items-center gap-2'><span className='right-rounded w-5 h-5 inline-block'></span> <span>This report Has been Successfully Submitted</span></div>

              <div>
                <Link to={''} className='bg-white border border-[#C8C8C8] rounded xl:py-[0.417vw] py-[6px] xl:px-[0.625vw] px-[12px] inline-block' onClick={() => setConfirm(false)}>Close</Link>
              </div>
            </div>
          </Dialog>
        </div>
      </div>
      {/*Col-8*/}


    </>
  );
}